import { useSyncExternalStore } from 'react';

/**
 * Largura que a coluna "Ditar documentos" está tirando da tela, em estado do
 * React — o `--voice-dock-w` (CSS) sozinho não avisa ninguém. O Shell desconta
 * dela pra recolher o menu e a agenda; a agenda, pra decidir se encaixa.
 * 0 = fechada, recolhida ou sobreposta (tela estreita).
 */
let reservedPx = 0;
const listeners = new Set<() => void>();

export function setVoiceDockPx(px: number): void {
  if (px === reservedPx) return;
  reservedPx = px;
  listeners.forEach((f) => f());
}

export function useVoiceDockPx(): number {
  return useSyncExternalStore(
    (f) => {
      listeners.add(f);
      return () => {
        listeners.delete(f);
      };
    },
    () => reservedPx,
    () => 0,
  );
}
